module.exports = __webpack_public_path__ + "img/locale_icon.26170507.svg";